// 音声録音データ保存サービス
export class AudioRecordingService {
  
  /**
   * 録音データをAPIに保存
   * @param {string} examinationId - 診察ID
   * @param {Object} recordingData - 録音データ
   * @param {Date} recordingData.startedAt - 録音開始時刻
   * @param {Date} recordingData.endedAt - 録音終了時刻
   * @param {string} recordingData.transcript - 文字起こし結果
   * @param {Blob} recordingData.audioFile - 音声ファイル
   * @returns {Promise<{success: boolean, data?: Object, error?: string}>} 成功時は{success: true, data: audio_recording}、失敗時は{success: false, error: string}
   */
  static async save(examinationId, recordingData) {
    try {
      const formData = new FormData()
      
      // 音声ファイルを追加
      if (recordingData.audioFile) {
        // Blobのtypeから適切なファイル名と拡張子を決定
        const blob = recordingData.audioFile
        const mimeType = blob.type
        let filename = "recording.webm"

        if (mimeType.startsWith("audio/mp4") || mimeType.startsWith("video/mp4")) {
          filename = "recording.mp4"
        } else if (mimeType.startsWith("audio/webm") || mimeType.startsWith("video/webm")) {
          filename = "recording.webm"
        }

        const audioFile = new File([blob], filename, { type: mimeType })
        formData.append("audio_recording[audio_file]", audioFile)
      }
      
      // その他のデータを追加
      formData.append("audio_recording[started_at]", recordingData.startedAt.toISOString())
      formData.append("audio_recording[ended_at]", recordingData.endedAt.toISOString())
      formData.append("audio_recording[transcript]", recordingData.transcript)
      
      // SOAPテキスト作成フラグを追加
      if (recordingData.createSoap) {
        formData.append("audio_recording[create_soap]", "true")
      }

      // 端末で選択中のSOAPテンプレートIDを添付（複数端末の競合防止）
      const templateId = recordingData.soapPromptTemplateId ||
        localStorage.getItem('device_soap_prompt_template_id') ||
        document.querySelector('[data-soap-prompt-selector-target="select"]')?.value
      if (templateId) {
        formData.append("audio_recording[soap_prompt_template_id]", templateId)
        formData.append("soap_prompt_template_id", templateId)
      }
      
      const response = await fetch(`/api/examinations/${examinationId}/audio_recordings`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: formData
      })
      
      const data = await response.json()
      
      if (!response.ok) {
        throw new Error(data.errors?.join(", ") || `HTTP error! status: ${response.status}`)
      }
      
      return {
        success: true,
        data: data
      }
    } catch (error) {
      console.error("[AudioRecordingService] API呼び出しエラー:", error)
      return {
        success: false,
        error: error.message
      }
    }
  }
}